import { useEffect } from 'react';

export function useRefetchRidersOnTabFocus(
  isEnabled: boolean,
  query: string,
  refetchRiders: (query: string) => void
): void {
  useEffect(() => {
    if (!isEnabled) {
      return undefined;
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && query) {
        refetchRiders(query);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [isEnabled, query, refetchRiders]);
}
